let Backbone = require("backbone");
let main = function(){
    return Backbone.View.extend({
        el: "#tooieStatusModal",
        initialize:function(){
        },
        show: function () {
            this.$el.modal("show");
        },
        hide: function () {
            this.$el.modal("hide");
        },
        render:function(){
            if(this.model.get("status")==""){
                console.log("offline end");
                this.$el.attr("class","modal");
                this.hide();
                return;
            }
            this.$el.addClass(this.model.get('status'));
            this.show();
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/TooieStatusView.js